import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApActionIconComponent, ApIconComponent } from '@ap/icon';

import { BreadcrumbComponent } from './breadcrumb.component';

@NgModule({
    declarations: [BreadcrumbComponent],
    exports: [BreadcrumbComponent],
    imports: [ApButtonComponent, CommonModule, ApIconComponent, ApActionIconComponent]
})
export class BreadcrumbModule {}
